<template>
	<div class="newFixedNav">
		<div class="navigation">
				<div class="existing address-notification"   v-if="notificationPopup">
						<h4>Showing Stores delivering to Home.</h4>
                        <p class="address-notification-text">Want it Delivered elsewhere? Change the delivery location here.</p>
						<button @click="closenotification" class="address-notification-btn">OK GOT IT</button>
					</div>
			<div class="burger" @click="toggleNav" v-if="$route.path == '/'">
				<span></span>
				<span></span>
				<span></span>
			</div>
			<div class="burger back" v-else >
				<img src="/img/arrow-left-icons-black.svg" alt="back icon" @click="$router.go(-1)">	
			</div>	
			<Logo />
			
			<!-- location Dropdown goess here -->
			<div class="link locationWraper" v-if="this.$root.isMobile == false " :class="{ forDesktop : isMobileLocation }" >
				<div class="dropdown menuLocation" v-click-outside="closeLocation">
					<button
						class="btn btn-primary dropdown-toggle"
						@click="toggleLocation"
						type="button"
						data-toggle="dropdown"
					>
						<img src="/img/locationMarker.png"  lang="img-fluid" alt="">
						<span
							style="
								border-bottom: 1px solid var(--main-color);
								color: #fff;
								text-transform: uppercase;
								margin: 0 10px;
							"
							>{{ this.$root.cityName }}</span>
						{{ this.$root.locationAddress }} <span class="caret"></span>
					</button>
					<ul class="dropdown-menu locationDrop " v-if="isLocation">
						<ul class="place-dropdown autosuggest" v-if="autosuggestion">
							<li
							style="line-height:17.5px"
							  v-for="(suggest, i) in suggestions"
                              :key="i"
							  @click='getlatlong(suggest.place_id,suggest.terms,suggest.types)'
							>
							{{suggest.description}}
							</li>
						</ul>
						<li>
								  <!-- <input
										class="searchLocation"
										placeholder="Search your Area"
										v-model="placeinput"
										@keyup="placesuggest"
									/> -->
									<input class="searchLocation"
									placeholder="Search your Area" 
									id="infd" 
									type="text"
									@input="placesuggest()"/>
								
							<!-- <gmap-autocomplete
								placeholder="Search your Area1"
								class="searchLocation"
								@place_changed="setPlace"
							>
							</gmap-autocomplete> -->
						</li>
						
						<li class="getLocation" @click="getLocation">
							<a href="javascript:void(0)">
								<img src="/img/detect.png" class="px-1 float-left" />
								<div class="float-left pl-1">
									<h4>Get Current Location </h4>
									<small class="mt-1 p-0 mb-1">Using GPS</small>
								</div>

								<span
									v-if="islocationDetected"
									class="cssLoader float-right"
								></span>
								<!-- <span class="cssLoader float-right" ></span> -->
							</a>
						</li>
						<span class="savedAddressWrap" v-if="this.$root.customer_id&&this.$root.address.length>0">
							<small class="savedHeading">Saved Address</small>
							<li
								@click="assignAddress(address.latitude, address.longitude)"
								class="savedAddressLi"
								v-for="(address, i) in addresses"
								:key="i"
							>
								<a href="javascript:void(0)">
									<i
										v-if="address.address_type == 'home'"
										class="fa fa-home float-left"
									></i>
									<i v-else class="fa fa-briefcase float-left"></i>
									<div class="float-left pl-1">
										<h4>{{ address.address_type }}</h4>
										{{ address.street_address }}, {{ address.city }}
									</div>
								</a>
							</li>
						</span>
					</ul>
					
				</div>
			</div>
 
		<div class="input activeSearch newNavActiveSearch" :class="{navRemoveIcon:navSearchclose , activeSearchMobile :isMobileSearch }" >

				
						<input type="text"
                              @keyup.enter="enterFirstLink"
                              @keyup.esc="newNavCloseSearch"
                              class="navField navSearchInputField"
                              placeholder="Search for Products, Brands and more"
                              id="navSearchvalue"
                              @input="navDebouncesearch()"/>
					<div v-if="navSearchloader" class="newspinner"> <i class="fa fa-spinner fa-spin"></i> </div>
                    <div v-if="navSearchclose" @click="newNavCloseSearch" class="crossIcons newcrossicon">X</div>
	
			
			<div class="navNewSearch" v-if="newNavSearch">

				<div v-if="navNewSearching" class="nawSearchNotch ">
                    <div class="nawSearchNotchresult">Searching in WNDW</div>
                </div>
				<div v-if="navNoResult" class="nawSearchNotch ">
                    <div class="nawSearchNotchresult ">  No result found  </div>
                </div>


				
				<div class="forMobile mobileSearchTabs" v-if="navSearchResult" >
					<div> <span @click="topResultClick" :class="{'currentTab': topResult}"> Top Result </span> </div>
					<div> <span @click="matchingStoreClick" :class="{'currentTab': matchingStore}"> Matching Stores </span> </div>
				</div>
				<div v-if="navSearchResult" class="nawSearchNotch nawSearchNotchResult navSerachReuslts ">
					
                    <div class="nawSearchNotchresult navSearchProduct " :class="{showSearchResult :topResult}" > 
						<router-link
							class="categoryLink mt-2"
							@click.native="newNavSearch = false" 
							:to="{ path:'/category/' + category.url_key + '.html' , query: { sq: search},}"
							v-for="(category, i) in products"
							:key="`${category.id_category}-${i}`">
							<b class="search-text">{{ search }}</b> <span class="search-in"> in </span>  <span><b>{{ category.name }}</b></span>
						</router-link>
					</div>
					<div class="nawSearchNotchresult navSearchStore" :class="{showSearchResult :matchingStore}">
						<p v-if="stores != '' " class="headingName">Matching Stores</p>
						<router-link :class="{ storenamehighlight: hightlightstore.includes(store.id) }"
									:to="{
                                    name: 'list',
                                    query: {
                                    store:store.id,
                                    category: searchcategory,
                                        name:'All Products',
                                        isFromStore:true,
                                        sq:search,
                                        url_key: 'all'
                                    },
                                    params: {
                                    menu_url_key: `store-${store.id}`
                                    }
									}"
									v-for="(store, i) in stores"
									:key="`${store.id_category}-${i}`"
									@click.native="newNavSearch = false">
									{{ store.name }}
							</router-link>
							<!-- <p v-if="categories != ''">Matching Category</p>
								<router-link
									:to="{ path:'/category/' + categorie.url_key + '.html' , query: { categorie: categorie.id_category } }"
									v-for="(categorie, i) in categories"
									:key="`${categorie.id_category}-${i}`"
									@click.native="isSearch = false"
								>
									{{ categorie.name }}
								</router-link> -->
					</div>
				</div>
            </div>
	


		</div>
		
		<div v-if="isActive" class="sidebarNav">
				<div class="navMenu ">
					<div class="sideUserSection">
						<div class="userIcon">
							<img src="/img/sideUser.png" class="img-fluid" alt="">
						</div>
						<div class="sideUserDetails">
							<p 
							v-if="!this.$root.customer_id"
							@click="toggleLogin" >LOGIN / SIGN UP</p>
							<div v-else>
								<div class="sideUserName"> 
									<p>Hello, {{this.$root.customerDetails.name}}</p> 
									<span  @click="toggleNav" > <router-link :to="{ name: 'profile' }">View Account</router-link> </span>
									<!-- <small>{{this.$root.customerDetails.number}}</small> -->
								</div>
							</div> 
						</div>
					</div>
					<div class="sideLocationWrap">
						<div class="sideLocation">
							<img src="/img/sideLocation.png" class="img-fluid" alt="">
							<p class="sideLocationText">{{ this.$root.cityName }} {{ this.$root.locationAddress }}</p>
							<p class="changeLocation" @click="toggleLocation"><span @click="toggleNav">Change</span></p>
						</div>
					</div>
					<button class="button mobileMenuBack" v-if="navStack.length!=0" @click="backNav">
						<i class="fa fa-angle-left pr-2"></i>  <span class=""> Back</span>
					</button>
					
				    <button class="button mobileMenuBack" v-if="navStack.length!=0" @click="visitPage">
						 <span class=""> Visit All</span><span style="margin-left:10px;color:var(--main-color)"><strong>{{navStack[navStack.length-1].name}}</strong></span>
					</button>
					<transition-group class="menu" tag="ul" name="slide">
						
						<li @click="goPage(Menu.menu_url_key)" v-if="isGoPage==true" v-for="(Menu, i) in dataMenu" :key="Menu.menu_url_key">
							<label :for="'drop-' + i" class="toggle labelMenu">
							
							<router-link
									class="link"
									:to="'/category/' + Menu.menu_url_key + '.html'"
									>{{ Menu.name }}</router-link
							>
								<img
									v-if="Menu.childs"
									 @click="menuData(i, Menu.name)"
									class="menuIcon"
									src="/img/iright.png"
								/>
							</label>
						</li>

						<li v-if="isGoPage==false" v-for="(Menu, i) in dataMenu" :key="Menu.menu_url_key"  @click="menuData(i, Menu.name)">
							<label :for="'drop-' + i" class="toggle labelMenu">
							<span>{{Menu.name}}</span>
							
								<img
									class="menuIcon"
									src="/img/iright.png"
								/>
							</label>
						</li>
						
                </transition-group>

				<div class="menu-background">
						<li class="menu-li" v-if="this.$root.customer_id" @click="visittopage('order')">
							<label class="labelMenu">
								<a class="menu-list link">My Orders</a>
							</label>

						</li>
						<li class="menu-li" v-if="this.$root.customer_id" @click="visittopage('StoreCredit')">
							<label class="labelMenu">
								<a class="menu-list link">WNDW Credits</a>
							</label>

						</li>
						<li class="menu-li" v-if="this.$root.customer_id" @click="wishlist">
							<label class="labelMenu">
								<a class="menu-list link">My Wishlist</a>
								
							</label>

						</li>
						<li class="menu-li" v-if="this.$root.customer_id" @click="visittopage('cart')">
							<label class="labelMenu">
								<a class="menu-list link">
                                    Cart
                                </a>
								
							</label>

						</li>
						<li class="menu-li" v-if="this.$root.customer_id" @click="signOut">
							<label class="labelMenu">
								<a class="menu-list link">Sign Out</a>
							</label>

						</li>
<!-- 
							<li class="menu-li-one">
							<label class="labelMenu">
								<a class="menu-list link" href="#" >Customer Services</a>
								<span class="toggle-icon"></span>
							</label>

						</li> -->
							<!-- <li class="menu-li-one">
							<label class="labelMenu">
								<a class="menu-list link" href="#" >Company</a>
								<span class="toggle-icon"></span>
							</label>

						</li> -->
						<div  class="links menu-li-one">
					<h3
						class="footer__heading labelMenu "
						@click="toggle('com')"
						:class="{ active: footer_active === 'com' }"
					>
						Company
					</h3>
					<div class="mobile-view" :class="{ active: footer_active === 'com' }">
						<ul class="footerLinks">
							<li
								class="footerLink"
								v-for="(item, i) in this.$root.pages.company"
								:key="i"
								v-if="item.include_footer_menu === 'yes'"
								@click="bottomnavpage(item.url_key,item.id_category,item.menu_url_key)"
							>
							<a>{{ item.name }}</a>
								<!-- <router-link
							
									v-if="item.landing_page == null"
									:to="{
										path: '/page/' + item.url_key + '.html',
										params: {
											cat_id: item.id_category,
											menu_url_key: item.menu_url_key,
										},
									}"
									:key="item.id_category"
									>{{ item.name }}</router-link
								>
								<router-link
								
									v-else
									:to="{
										path: '/page/' + item.url_key + '.html',
										params: {
											cat_id: item.id_category,
											menu_url_key: item.menu_url_key,
										},
									}"
									:key="item.id_category"
									>{{ item.name }}</router-link
								> -->
							</li>
							</ul>
					</div>
				</div>

				<div class="links menu-li-one">
					<h3
						class="footer__heading labelMenu"
						@click="toggle('con')"
						:class="{ active: footer_active === 'con' }"
					>
						Customer Service
					</h3>
					<div class="mobile-view" :class="{ active: footer_active === 'con' }">
						<ul class="footerLinks">
							<li class="footerLink" @click="visittopage('contact_us')">
								<a>Contact Us</a>
							</li>
							<li
								class="footerLink"
								v-for="(item, i) in this.$root.pages.customer_service"
								:key="i"
								v-if="item.include_footer_menu === 'yes'"
								@click="bottomnavpage(item.url_key,item.id_category,item.menu_url_key)"
							>
							<a>{{ item.name }}</a>
								<!-- <router-link
								
									v-if="item.landing_page == null"
									:to="{
										path: '/page/' + item.url_key + '.html',
										params: {
											cat_id: item.id_category,
											menu_url_key: item.menu_url_key,
										},
									}"
									:key="item.id_category"
									>{{ item.name }}</router-link
								>
								<router-link
									v-else
									
									:to="{
										path: '/page/' + item.url_key + '.html',
										params: {
											cat_id: item.id_category,
											menu_url_key: item.menu_url_key,
										},
									}"
									:key="item.id_category"
									>{{ item.name }}</router-link
								> -->
							</li>
						</ul>
					</div>
				</div>
				</div>

				</div>
				<div class="hide" @click="toggleNav"></div>
			</div>
			<div class="bottomMenu" v-if="$route.name == 'Home' || $route.name == 'dashboard' || $route.name == 'Wishlist' || $route.name == 'Categories'" >
			
			<div class="bottomBox" @click="pushToHome">
				<img v-if="$route.name == 'Home'" src="/img/bottomHomeActive.png" class="img-fluid" alt="">
				<img v-else src="/img/bottomHome.png" class="img-fluid" alt="">
				<p>Home</p>
			</div>
			<div class="bottomBox" @click="pushToCategory">
				<img v-if="$route.name == 'Categories'" src="/img/bottomcategoryActive.png" class="img-fluid" alt="">
				<img v-else src="/img/bottomcategory.png" class="img-fluid" alt="">
				<p>Categories</p>
			</div>
			
			<div class="bottomBox" @click="pushToBrands">
				<img src="/img/bottomStore.png" class="img-fluid" alt="">
				<p>NearBy Store</p>
			</div>
			<div v-if="this.$root.customer_id" class="bottomBox" @click="goToAccount" >
				<img v-if="$route.name == 'dashboard' || $route.name == 'order' || $route.name == 'order-detail' || $route.name == 'address_book' || $route.name == 'profile' " src="/img/bottomUserActive.png" class="img-fluid" alt="">
				<img v-else src="/img/bottomUser.png" class="img-fluid" alt="">
				<p>Account</p> 
			</div> 
			<div v-else class="bottomBox" @click="toggleLogin" >  
				<img src="/img/bottomUser.png" class="img-fluid" alt="">
				<p>Account</p> 
			</div> 
			<div v-if="this.$root.customer_id" class="bottomBox" @click="bottomnavwishlist">
				<img  v-if="$route.name == 'Wishlist'" src="/img/bottomWishActive.png" class="img-fluid" alt="">
				<img v-else src="/img/bottomWish.png" class="img-fluid" alt="">
				<span class="bottomBadge">{{ this.$root.wishListProducts }}</span>
				<p>Wishlist</p>
			</div>
			<div v-else class="bottomBox" @click="toggleLogin" v-ripple>
				<img  v-if="$route.name == 'Wishlist'" src="/img/bottomWishActive.png" class="img-fluid" alt="">
				<img v-else src="/img/bottomWish.png" class="img-fluid" alt=""> 
				<p>Wishlist</p>
			</div>
		</div>
			<!--<div class="location">
				<span>Noida</span>, Uttar Pradesh,India <span class="locationIcon"></span>
			</div>-->
			<!-- v-click-outside="closeLocation" -->
			<div class="icons">
				<div class="forMobile"> 
					<div v-if="this.$root.isMobile == true " class="link locationWraper mobileLocation">
						<div class="dropdown menuLocation" v-click-outside="closeLocation"> 
							 <img src="/img/locationMarker.png" @click="toggleLocation" class="img-fluid" alt="">
							<ul class="dropdown-menu locationDrop" v-if="isLocation">
								
									<ul class="place-dropdown autosuggest" v-if="autosuggestion">
										<li
										style="line-height:17.5px"
										v-for="(suggest, i) in suggestions"
										:key="i"
										@click='getlatlong(suggest.place_id,suggest.terms,suggest.types)'
										>
										{{suggest.description}}
										</li>
									</ul>
								<li>
									<!-- <input
										class="searchLocation"
										placeholder="Search your Area"
										v-model="placeinput"
										@keyup="placesuggest"
									/> -->
									<input class="searchLocation"
									placeholder="Search your Area" 
									id="infd" 
									type="text"
									@input="placesuggest()"/>
									<!-- <gmap-autocomplete
										placeholder="Search your Area2"
										class="searchLocation"
										@place_changed="setPlace"
									>
									</gmap-autocomplete> -->
								</li>
								<li class="getLocation" @click="getLocation">
									<a href="javascript:void(0)">
										<img src="/img/detect.png" class="px-1 float-left" />
										<div class="float-left pl-1">
											<h4>Get Current Location </h4>
											<small class="mt-1 p-0 mb-1">Using GPS</small>
										</div>

										<span
											v-if="islocationDetected"
											class="cssLoader float-right"
										></span> 
									</a>
								</li>
								<span class="savedAddressWrap" v-if="this.$root.customer_id&&this.$root.address.length>0">
									<small class="savedHeading">Saved Address</small>
									<li
										@click="assignAddress(address.latitude, address.longitude)"
										class="savedAddressLi"
										v-for="(address, i) in addresses"
										:key="i"
									>
										<a href="javascript:void(0)">
											<i
												v-if="address.address_type == 'home'"
												class="fa fa-home float-left"
											></i>
											<i v-else class="fa fa-briefcase float-left"></i>
											<div class="float-left pl-1">
												<h4>{{ address.address_type }}</h4>
												{{ address.street_address }}, {{ address.city }}
											</div>
										</a>
									</li>
								</span>
							</ul>
						</div>
					</div>
					
			 	</div>
				<div
					title="User"
					class="user-icon forDesktop"
					v-if="!this.$root.customer_id"
					@click="toggleLogin" > 
				<!-- <span class="cart-text">Login</span> -->
				</div>
				<router-link :to="{ name: 'dashboard' }" class="user-icon-link forDesktop">
				<div class="user-icon" v-if="this.$root.customer_id">
					<!-- <span class="cart-text">Account</span> -->
					<div class="userDrop">
						<div class="userData">
							<router-link :to="{ name: 'profile' }"> 
								<strong>Hello {{this.$root.customerDetails.name}}</strong><br>
								<small>{{this.$root.customerDetails.number}}</small>
							</router-link>
						</div>
						<div class="userData">
							<!-- <router-link :to="{ name: 'address_book' }"> Address </router-link> -->
							<router-link :to="{ name: 'order' }">My Orders</router-link>
							<!-- <router-link :to="{ name: 'order' }">Wishlist</router-link> -->
							<!-- <router-link :to="{ name: 'order' }">Contact</router-link> -->
						</div>
						<div class="userData">
							<router-link :to="{ name: 'dashboard' }"> Dashboard </router-link>
							<router-link :to="{ name: 'StoreCredit' }">WNDW Credits</router-link>
							<router-link :to="{ name: 'address_book' }">Address</router-link>
						</div> 
						<div class="userData">
							<!-- <router-link :to="{ name: 'StoreCredit' }">Edit Profile</router-link> -->
							<a href="#" @click="signOut"> Sign Out </a>
						</div>
					</div>
				</div>
				</router-link>
				<div
					class="mobile wishlist-icon iconWithBadge forDesktop"
					v-if="this.$root.customer_id"
					@click="wishlist"
				>
					<span class="badge">{{ this.$root.wishListProducts }}</span>
					<!-- <span class="cart-text">Wishlist</span> -->
					
				</div>
				<div class="desktop search-icon" @click="toggleSearch">search</div>
				<!-- <div class="desktop  store-icon" >store
        </div> -->

				<div class="iconWithBadge cart-icon" @click="minicart_show_hide">
					<span class="badge" v-text="this.$root.cart_product.length"> </span>
					<!-- <span class="cart-text">Cart</span> -->
				</div>
			</div>
		</div>
		<!-- <div class="diff-store-popup" v-if="covidMsg">
			<div class="diff-store-popup-modal-content">
				<div class="alertInfo">  
					<p>Due to COVID restrictions, 263 Beauty & Skincare, Centro, Chera Silver Jewellery, Colorbar, The Doggy Bakery, Iris,<br>New Fruit Land, Samsung, Smoor and V Star may be unserviceable. We apologise for the inconvenience.</p>
				</div>
				<button @click=" covidMsg = false" class="new-check-button">ok</button>
			</div>
		</div> -->
		<div class="diff-store-popup" v-if="diffStore">
			<div class="diff-store-popup-modal-content">
				<div class="alertInfo">  
					<p>You have added an item from a different store. Shipping charges may vary accordingly.</p>
				</div>
				<button @click="CloseDiffStoreCheckPopup" class="new-check-button">ok</button>
			</div>
		</div>
		<Menu />
	</div>
</template>
<style>
.place-dropdown {
    position: absolute;
    top: 17%;
    left: 9px;
    z-index: 1000;
    float: left;
    margin: .125rem 0 0;
    font-size: 1rem;
    color: #212529;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
}
.autosuggest {
    min-width: 280px;
    display: block;
    margin-top: 30px;
    padding: 0;
    max-height: 400px;
    border: none;
    box-shadow: 0 0px 10px rgb(0 0 0 / 24%);
    border-radius: 5px;
}

.autosuggest li:first-child{
	border-bottom: 1px solid #f5f0f0;
}
.spinner {
	position: absolute;
	top: 0px;
	font-size: 16px;
	right: 20px;
	
	
}
.user-icon-link{
	padding: 0px;
	/* margin-right: 15px; */
	color: var(--font-dark-blue);
}
.user-icon-link:hover{
	color: var(--main-color);
}

.search-in{
	text-transform: lowercase;
	color:  var(--font-dark-blue)  !important; 
	/* margin-right: 5px; */
}


	.mobileMenuBack{
		border: none;
		padding: 10px;
		background: none;
		font-family: 'lhmRegular';
		border-bottom: 1px solid #eee;
		width: 100%;
		text-align: left;
		cursor: pointer;
	}
	.savedHeading {
		margin-top: 10px;
		margin-left: 0;
		position: sticky;
		top: 0;
		padding-top: 4px;
		padding-bottom: 4px;
		background-color: #fff;
		width: 100% !important;
		padding-left: 10px !important;

	}
	.savedAddressWrap{
		display: inline-block;
		height: 200px;
		overflow: hidden;
		overflow-y: auto;
	}
	.savedAddressLi a i {
		width: 20px;
		text-align: center;
		margin-top: 4px;
		color: var(--main-color);
		font-size: 14px;
	}
	.savedAddressLi:hover h4{
		color: var(--main-color);
	}
	.savedAddressLi a .fa-home{
		font-size:  var(--font-size-heading);
    	margin-top: 0px;
	}

	.savedAddressLi div {
		font-size: var(--font-size-regular);
		line-height: 15px;
		padding-left: 6px !important;
		width: 90%;
	}
	.savedAddressLi a h4 {
		font-size: 14px;
		font-family: "lhmSemiBold";
		color: #000;
		text-transform: uppercase;
	}
	.cssLoader {
		width: 13px;
		height: 13px;
		display: inline-block;
		border: 2px solid var(--main-color);
		border-top: 2px solid #fff;
		border-radius: 50%;
		margin-left: 5px;
		margin-bottom: -2px;
		animation: locationLoader 0.8s infinite;
	}
	@keyframes locationLoader {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}
	.crossIcons {
		position: absolute;
		right: 13px;
		z-index: 9;
		top: 6px;
		cursor: pointer;
		color: #000 !important;
	}
	.user-icon {
		position: relative;
		padding: 5px 0;
		cursor: pointer;
		padding-right: 5px;
		color: #fff;
		/* border-right: 1px solid rgb(255 255 255 / 60%); */
		align-items: center;
    	display: inline-table;
	}

	.user-icon .userDrop {
		display: none;
		position: absolute;
		top: 40px;
		z-index: 1016;
		width: 250px;
		left: 35%;
		-webkit-transform: translate(-50%, -0);
		transform: translate(-50%, -0);
		background-color: #fff;
		-webkit-box-shadow: 0 0px 10px rgb(0 0 0 / 24%);
		box-shadow: 0 0px 10px rgb(0 0 0 / 24%);
		padding: 15px;
	}
	/* uncoment the below line for user dropdown */
	.user-icon:hover .userDrop {
		display: block;
	}
	/* .user-icon .userDrop::before {
		content: "";
		width: 10px;
		height: 10px;
		background-color: rgb(255 255 255);
		position: absolute;
		left: 50%;
		transform: translate(-50%, -50%) rotate(45deg);
		box-shadow: -1px -1px 0px #ccc;
	} */
	.user-icon .userDrop .userData {
		font-size: 16px;
		text-align: left;
		display: block;
		border-bottom: 1px solid #f5f0f0;
		padding: 10px 0;
	}
	.user-icon .userDrop .userData:last-child {
		border-bottom: none;
	}
	.user-icon .userDrop .userData a {
		padding: 0px !important;
		color: var(--font-dark-blue);
		display: inline-block;
		width: 100%;
		line-height: normal;
		font-size: 14px ;
	}
	.user-icon .userDrop .userData a:hover {
		/* font-family: 'lhmRegular'; */
		color: var(--main-color) !important;
	}
	.iconWithBadge {
		position: relative;
		color: #fff;
		cursor: pointer;
	}
	.searchField {
		position: relative;
		z-index: 6;
	}

	.searchBrand p,
	.searchStores p {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		font-family: "lhmRegular";
		color: #000;
	}
	.searchProducts a {
		text-decoration: none;
		color: #626262;
		font-size: 14px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		font-family: "lhmRegular";
		color: #000;
	}

	.searchProducts > a > p {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		font-family: "lhmRegular";
		color: #000;
		margin: 0px;
	}
	.search  {
		background: transparent;
		height: auto;
		
		position: absolute;
		z-index: 5;
		width: 100%;
		top: 40px;
	}
	.searchNotch {
		overflow-y: auto;
		display: flex;
		flex-direction: row-reverse;
		max-height: 400px;
		border: 1px solid #d4d4d4;
		margin-top: 10px;
		background-color: #fff ;
	}
	.search::before {
		position: absolute;
		content: "";
		width: 10px;
		height: 10px;
		background: white;
		left: 30px;
		top: 5px;
		transform: rotate(45deg);
		border-top: 1px solid #d4d4d4;
		border-left: 1px solid #d4d4d4;
	}

	.search__stores,
	.search__brands > img {
		width: 100px !important;
		/* height: 100px !important; */
	}
	.desktop.search-icon {
		display: none;
	}
	.isMobile {
		display: none;
	}
	.desktop.store-icon {
		font-size: 0;
	}
	.menuContainer.sticky .desktop {
		display: block;
		transition: all 5s ease-in-out;
	}
	.sidebarNav {
		display: none;
	}
	.navigation {
		height: 55px;
		background: #b20101;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		/* display: block; */
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 99;
	}
	.inputSearch {
		margin: auto;
	}
	.navigation > img {
		margin-left: 15px;
		height: 55px;
	}
	.burger {
		display: none;
	}
	.input {
		/* width:  30px; */
		margin-right: auto !important;
		position: relative;
	}
	.wishlist-icon .badge{
		left: 25px;
	}
	.badge {
		position: absolute;
		width: 15px;
		height: 15px;
		padding: 2px;
		background: #fff;
		color: var(--main-color);
		font-size: 9px;
		font-family: "lhmSemiBold";
		/* line-height: 15px; */
		text-align: center;
		border-radius: 15px;
		top: 0px;
		left: 12px;
	}
	.locationIcon::after {
		content: url(/img/locationIcon.png);
		margin-top: 2px;
	}
	.field {
		width: 100%;
		padding: 8px;
		padding-left: 10px;
		border: none;
		/* background: #eeeeee; */
		border-radius: 0px;
		/* font-style: italic; */
		font-size: var(--font-size-regular);
	}
	
	input.field.searchInputField {
		display: none;
	}

	.input.activeSearch {
		width: 550px;
		transition: all 300ms ease-in-out;
		margin: auto;
		
		
	}
	.input.activeSearch input.field.searchInputField {
		display: block;
		background: #fff;
		border: 1px solid #fff;
		/* width: 60%; */

		padding-left: 10px;
		transition: width 0.2s ease-in-out;
		color: #888;
		border-radius: 2px;
    	/* box-shadow: 0 0 10px #868686; */
	}
	
	.input.activeSearch input.field.searchInputField::placeholder{
		color: #888;
	}
	
	.input.activeSearch input.field.searchInputField:focus {
		border: 1px solid #fff;
		width: 100% !important;
		transition: width 0.2s ease-in-out;
	}
	.
	.field.searchInputField.searchField {
		border: 1px solid #fff;
		width: 100% !important;
		transition: width 0.2s ease-in-out;
	}
	
	input.field:focus {
		outline: none;
		border: 1px solid #fff;
	}
	
	.input::before {
		position: absolute;
		right: 23px;
		top: 6px;
		background-color: transparent;
		cursor: pointer;
		border: none;
		font-size: 0px;
		padding: 0px;
		width: 30px;
		width: 12px !important;
		height: 12px !important;
		font-size: 16px;
		color: var(--main-color);
		content: "\e801";
		font-family: "fontello";
		font-weight: bold;
	}
	/* .input.activeSearch::before {
	  top: 5px;
	} */
	.backdrop {
		display: block;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 4;
		position: fixed;
		left: 0px;
		top: 0px;
	}
	.location {
		font-family: "lhmRegular";
		font-size: var(--font-size-regular);
		line-height: 24px;
		/* margin-left: auto; */
	}
	.location > span {
		color: var(--main-color);
		text-decoration: underline;
		font-family: "lhmBold";
		font-size: var(--font-size-regular);
		line-height: 24px;
	}
	.icons {
		/* margin-left: auto; */
		/* margin-right: 2em; */
		display: flex;
		width: 15%;
    	justify-content: flex-end;
	}
	/* .icons > div {
		width: 30px;
	} */
	.icons > div:not(:last-child) {
		margin-right: 5px;
	}
	.slide-leave-active {
		transition: 0s;
	}
	.slide-enter-active {
		transition: 100ms;
	}
	.slide-enter {
		transform: translate(100%, 0);
	}
	.slide-leave-to {
		transform: translate(-100%, 0);
	}
	.menuLocation {
		padding: 12px 0;
	}
	 
	/* @keyframes fadeIn { from { opacity: 0; transform: translate3d(-20%, 0, 0); } to { opacity: 1; transform: translate3d(0, 0, 0); } }  */
	@keyframes slide {
		from {
			opacity: 0;
			transform: translate3d(0, 0, 10%);
		}
		to {
			opacity: 1;
			transform: translate3d(0, 0, 0);
		}
	}
	/* Responsive  */
	@media screen and (max-width: 767px) {
	     /* background: rgb(189,118,118); */
   		.navNewSearch::before  {
	   		display: none;
   		}
		.crossIcons.newcrossicon {
			right: 18px !important;
    		font-size: 19px !important;
    		top: 9px !important;
			color: #8e8e8e;
		}
		.input.activeSearch input.field.searchInputField:focus {
			border: 1px solid #d4d4d4;
			width: 98% !important;
			transition: width 0.2s ease-in-out;
		} 
		.navSerachContainer {
			margin: 6px;
		}
		.navSearchProduct , .navSearchStore {
			display: none !important;
		}
		.nawSearchNotchresult.showSearchResult  {
			display: block !important;
			padding: 0 1rem !important;
			
		}
		.navSerachReuslts {
			overflow-y: scroll;
		}
		.user-icon .userDrop {
			top: 33px;
			left: 30%;
		}
		.navigation .input.isMobile {
			display: block;
		}
		.mobile {
			display: none;
		}
		.mobile.fieldLogin {
			display: block;
		}
		.desktop,
		.isMobile {
			display: block;
			margin-right: 12px;
		}
		.desktop > img,
		.icons > div > img {
			width: 18px;
		}
		.badge {
			top: 0px;
			right: 5px;
		}
		.icons > div:not(:last-child) {
			margin: 0px;
		}
		.location {
			display: none;
		}
		.navigation {
			flex-direction: column;
			position: fixed;
			z-index: 9;
			width: 100%;
			background: #fff;
			/* margin: 5px 5px; */
			/* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
			align-items: flex-start;
		}
		.navigation + div {
			margin-top: 65px;
			display: inline-block;
		}
		.navigation > img {
			margin-left: 0px;
		}
		.slick-dots {
			bottom: 10px !important;
		}
		.icons {
			align-self: flex-end;
			position: absolute;
			top: 20px;
			right: 0px;
			box-sizing: border-box;
			padding: 0px 5px;
			width: auto;
		}

		.input {
			width: 100%;
			position: relative;
			overflow: hidden;
			border-radius: 5px;
			margin: 0px 13px;
			display: none;
		}
		.search {
			position: absolute;
			width: 100%;
			min-width: 100%;
			padding: 4px;
			margin: 0px;
			background-color: transparent;
		}
		.search-sidebar {
			border-right: none;
		}
		.isMobile {
			display: block;
		}
		.btn-success {
			right: 10px;
		}
		.burger {
			display: block;
			position: absolute;
			left: 10px;
			cursor: pointer;
		}
		.sidebarNav {
			display: flex;
			width: 100%;
			background-color: rgba(0, 0, 0, 0.4);
			height: 100vh;
			overflow: scroll;
			z-index: 1;
			transition: all 100ms ease-in-out;
			border: 1px solid #eeeeee;
			top: 0px;
			position: fixed;
			left: 0;
			overflow: scroll;
			animation: slide 0.1s ease-in both;
		}
		ul.menu.menuFixed {
			height: 100vh;
			overflow: scroll;
		}
		.menu {
			list-style-type: none;
			margin-left: -40px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		}
		.desktop,
		.isMobile {
			display: block;
			margin-right: 12px;
		}
		.desktop > img,
		.icons > div > img {
			width: 18px;
		}
		.badge {
			top: 0px;
			right: 5px;
		}
		.icons > div:not(:last-child) {
			margin: 0px;
		}
		.location {
			display: none;
		}
		.navigation {
			flex-direction: column;
			position: fixed;
			z-index: 1;
			width: 100%;
			background: var(--main-color);
			/* margin: 5px 5px; */
		}
		.navigation + div {
			margin-top: 65px;
			display: inline-block;
		}
		.navigation > img {
			margin-left: 0px;
		}
		.slick-dots {
			bottom: 10px !important;
		}
		.icons {
			align-self: flex-end;
			position: absolute;
			top: 15px;
			right: 0px;
			box-sizing: border-box;
			padding: 0px 5px;
		}
		.input {
			width: 100%;
			position: relative;
			overflow: hidden;
			border-radius: 5px;
			margin: 0px 13px;
			display: none;
		}
		.isMobile {
			display: block;
		}
		.btn-success {
			right: 10px;
		}
		.burger {
			display: block;
			position: absolute;
			left: 10px;
		}
		.burger.back{
			top: 25%;
			left: 14px;
   			width: 12px;
			/* top: 50%;
			transform: translateY(-50%); */
		}

		.burger.back img{ 
			filter: invert(1);
			width: 100%;
		}

		.sidebarNav {
			display: flex;
			width: 100%;
			background-color: rgba(0, 0, 0, 0.4);
			height: 100vh;
			overflow: scroll;
			z-index: 1;
			transition: all 100ms ease-in-out;
			/* border: 1px solid #eeeeee; */
			top: 0px;
			position: fixed;
			left: 0;
			overflow: scroll;
			animation: slide 0.1s ease-in both;
		}
		ul.menu.menuFixed {
			height: 100vh;
			overflow: scroll;
		}
		.menu {
			list-style-type: none;
			margin-left: 0px;
			display: flex;
			flex-direction: column;
			max-width: 100%;
    		padding: 0;
		}
		.menu > li {
			padding: 10px 40px;
		}
		.labelMenu {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 6px 15px;
			margin-bottom: 0px;
		}
		.labelMenu > a {
			text-decoration: none;
			color: #000;
		}
		.menuIcon {
			width: 30px;
			height: 30px;
			background-color: #ececec;
			padding: 10px;
			cursor: pointer;
			position: absolute;
			right: 10px;
		}
		li.backNav {
			border-bottom: 1px solid #cccccc;
			font-weight: bold;
			margin-bottom: 5px !important;
			padding: 10px !important;
		}
		.navMenu {
			width: 80%;
			background: #ffffff;
			height: 100vh;
			overflow: scroll;
			z-index: 3;
		}
		.hide {
			width: 20%;
			height: 100vh;
		}
		.accordion {
			background-color: #eee;
			color: #444;
			cursor: pointer;
			padding: 0px;
			width: 100%;
			border: none;
			text-align: left;
			outline: none;
			font-size: 15px;
			transition: 0.4s;
		}

		/* .active, .accordion:hover {
			  background-color: #ccc; 
			} */

		.panel {
			padding: 0 18px;
			display: none;
			background-color: white;
			overflow: hidden;
		}
	.mobileSearch-sidebar {
		display:block !important;
	}
	.searchNotch{
		border: 0;
	}
	.search-sidebar.showResult {
		border: 1px solid #d4d4d4;
	}
	}
	
</style>
<script>
	import Logo from "./Logo.vue";
	import Menu from "./Menu.vue";
	import Account_dashboard from "./Account_dashboard.vue";
	import axios from "axios";
	import GoogleMap from "../../GoogleMap";
	import _ from "lodash";
	import { bus } from '../../main.js';
   var debouncetimer;
	export default {
		name: "Nav",
		components: {
			Logo,
			Menu,
			Account_dashboard,
			GoogleMap,
		},
		watch: {
			// search (newVal) {
			// 	this.isSearching = true 
			// 	this.debouncedGetSearchResult ()
			// }
		},
		data() {
			return {

				newNavSearch:false,
				navSearchloader:false,
				navSearchclose:false,
				navNewSearching:false,
				navNoResult:false,
				navSearchResult:false,

				//new search 
				isSearchSpin:false,
				searchSpinner:false,
				footer_active:'',
				isGoPage:false,
				visitMenu:[],
				suggestions:[],
				autosuggestion:false,
				placeinput:'',
				notificationPopup:false,
				covidMsg: true,
				topResult: true,
				matchingStore: false,
				diffStore: false,
				hightlightstore:[],
				searchcategory:'',
				isMobileLocation: true,
				isSearching: false, 
				isActive: false,
				dataMenu: this.$root.menu,
				navStack: [],
				windowWidth: null,
				addresses: [],
				search: "",
				isTyping: false,
				brands: null,
				isSearchActive: false,
				isSearch: false,
				stores: null,
				products: null,
				categories : null,
				islocationDetected: false,
				isMobileSearch: false,
				activeName: "brands",
				error: "",
				center: { lat: 45.508, lng: -73.587 },
				markers: [],
				places: [],
				currentPlace: null,
				isLocation: false,
			};
		},
		created() {
			
			if (this.$root.customer_id) {
				this.getAddress();
			}
			this.debouncedGetSearchResult = _.debounce(this.getStoresSearch, 500)

			bus.$on('buyingfromotherstores', (data) => {
				this.diffStore = true
			 
				//this.header = data;
			})
		},
		mounted() {
		   var olduser = localStorage.getItem("notification-flag");

			if(olduser){
				this.notificationPopup=true
			}
			this.dataMenu = this.$root.menu;
			
			var form = new FormData();
			form.append("lat", this.$root.location.lat);
			form.append("lng", this.$root.location.long);
			
			axios.post(`${this.$root.api_url}/pim/place-detail`,form)
				.then((res) => {
				
					if(res.data.data.google_sublocaility){
						this.$root.cityName = res.data.data.google_sublocaility;
					}
					else{
					this.$root.cityName = res.data.data.google_locality;
					}		
					this.$root.locationAddress = res.data.data.google_formatted_address;
				})
				.catch((err) => {
					console.log(err)		
				});
			// axios
			// 	.get(
			// 		`https://maps.google.com/maps/api/geocode/json?latlng=${this.$root.location.lat},${this.$root.location.long}&key=AIzaSyABzA9XnM_g51esLxbDQdAdZAjtz3wjIMc`
			// 	)
			// 	.then((response) => {
			// 		let add = response.data.results
			// 		let location = null
			// 		for (let index = 0; index < add.length; index++) {
			// 			if(add[index].types.includes('sublocality_level_1')) {
			// 				location = add[index].formatted_address.split(",")
			// 				break;
			// 			}
			// 		}
			// 		if(!location) {
			// 			location = add[4].formatted_address.split(",");
			// 		}
			// 		this.$root.cityName = location[0];
			// 		location.shift();
					// this.$root.locationAddress = add.join(",");
					// this.$root.locationAddress = response.data.results[0].formatted_address;
					// 			// response.data.results[0].address_components[1].short_name;
				// 	// 			this.$root.cityName = response.data.results[4].address_components[0].long_name
				// })
				// .catch((error) => {
				// 	console.log(error);
				// });
		},
		methods: {
			
			closenotification(){
				this.notificationPopup=false
				localStorage.removeItem("notification-flag");
			},
			topResultClick(){
				this.topResult = true;
				this.matchingStore = false;
			},
			matchingStoreClick(){
				this.topResult = false;
				this.matchingStore = true;
			},
			CloseDiffStoreCheckPopup(){
				this.diffStore=false
			},
				toggle(name) {
					console.log("hi")
					console.log("name",name)
					console.log("footer active",this.footer_active)
				if (name != this.footer_active) {
					this.footer_active = name;
				} else {
					this.footer_active = "";
				}
			},
			pushToHome(){
				this.$router.push({path: '/'});
			},
			pushToBrands(){
				this.$router.push({path: '/mobile-brand.html'});
			}, 
			goToAccount(){
				// alert('asdfa');
				this.$router.push({path: '/account-dashboard.html'})
			},
			pushToCategory(){
				this.$router.push({path:"/categories.html"})
			},
			locationToggle(){
				this.isMobileLocation = !this.isMobileLocation;
			},

			getStoresData(){
				// axios
				// 				.get(
				// 					`${this.$root.api_url}/pim/get-nearby-data/${this.$root.location.lat}/${this.$root.location.long}`
				// 				)
				// 				.then(()=>{}).catch(err=>console.log(err))
			},
			// closeMobileLocation() {  
			// 	// alert('asdfas'); 
			// 	this.isMobileLocation = false;
			// },
			categoryProducts(){
				this.isSearch = false;
				this.isSearchSpin = false;
				this.$root.isStore=false;
				document.getElementById("navSearchvalue").value=''
				this.search = '';
				this.isSearchActive = false;
				this.$root.searchCount += 1;
								
									
			},
			assignAddress(lat, long) {
				
				this.$root.location.lat = lat;
				this.$root.location.long = long;
				$cookies.set(
					window.location.hostname.substring(10, 4) + "_location_lat",
					this.$root.location.lat,
					"1y"
				);
				$cookies.set(
					window.location.hostname.substring(10, 4) + "_location_long",
					this.$root.location.long,
					"1y"
				);
				this.getStoresData();
				this.$router.go();
				
				// console.log("called", lat);
				// this.reverseGeocode();
			},
			getAddress() {
				// console.log("called");
				var form = new FormData();
				form.append("customer_id", this.$root.customer_id);
				form.append("customer_session", this.$root.customer_session);

				axios
					.post(this.$root.cart_api + "/customer/get-last-addresses", form)
					.then((response) => {
						// console.log(response);
						if (response.data.success === true) {
							this.addresses = response.data.data;
							// this.$root.locationAddresses = response.data
						}
					})
					.catch((err) => {});
			},
			closeSearch() {
				this.isSearching=false
				this.isSearch = false;
				this.isSearchSpin = false;
				document.getElementById("navSearchvalue").value=''
				this.search = "";
				this.isMobileSearch = false;
			},
			newNavCloseSearch(){
					this.isMobileSearch = false;
					this.navSearchloader = false;
					this.navSearchclose = false;
					// this.navNoResult = false;
					// this.navSearchResult = false;
					this.newNavSearch = false;
					// this.navNewSearching = false;
					document.getElementById("navSearchvalue").value='';
					document.getElementById("navSearchvalue").blur()
					this.search = "";
					
			},
			
			closeLocation() {
				this.isLocation = false;
				this.autosuggestion=false
				this.suggestions=[]
			}, 
			signOut() {
				localStorage.removeItem("notification-flag");
				// isActive to close sidebar nav
				this.$root.address = []
			
				 this.$root.cart_product = [];
                    this.$root.pcart = null;
                  
					this.$root.cart_session='';
					this.$root.customer_session='';
				$cookies.remove(window.location.hostname.substring(10, 4) + "_customer");
				$cookies.remove( window.location.hostname.substring(10, 4) + "_cart")
                $cookies.remove( window.location.hostname.substring(10, 4) + "_carts")
				this.$root.customer_id = "";
				$cookies.remove(window.location.hostname.substring(10, 4) + "_cs");
				if (
					this.$route.name != "dashboard" ||
					this.$route.name != "order" ||
					this.$route.name != "StoreCredit" ||
					this.$route.name != "address_book"
				) {
					// console.log("caleed");
					this.$router.push({ name: "Home" });
				}
				this.toggleNav()
			},
			// toggleLogin() {
			// 	this.$root.login_popup = true;
			// },
			// reverseGeocode() {
			// 	const that = this;
			// 	console.log(this.$root.location.lat);
			// 	axios
			// 		.get(
			// 			`https://maps.google.com/maps/api/geocode/json?latlng=${this.$root.location.lat},${this.$root.location.long}&key=AIzaSyABzA9XnM_g51esLxbDQdAdZAjtz3wjIMc`
			// 		)
			// 		.then((response) => {
			// 			let add = response.data.results   
			// 			let location = null
						
			// 			for (let index = 0; index < add.length; index++) {
			// 				if(add[index].types.includes('sublocality_level_1')){
			// 					location = add[index].formatted_address.split(",")
			// 					break
			// 				}
			// 			}	
						
			// 			if(!location) {
			// 				location = add[4].formatted_address.split(",");
			// 			}

			// 			this.$root.cityName = location[0];
			// 			location.shift();
			// 			this.$root.locationAddress = location.join(",");
			// 			this.$root.locationAddress = response.data.results[0].formatted_address;
			// 				// response.data.results[0].address_components[1].short_name;
			// 				this.$root.cityName = response.data.results[4].address_components[0].long_name
			// 			this.islocationDetected = false;
			// 			this.$router.go();
			// 		})
			// 		.catch((error) => {
			// 			console.log(error);
			// 		})
			// 		.finally(() => (this.loading = false));
			// },

			toggleLocation() {
				this.isLocation = !this.isLocation;
			},
			getlatlong(placeid,terms,types){
				this.$root.locationPlaceId = placeid;
				$cookies.set(
					window.location.hostname.substring(10, 4) + "_location_placeId",
					this.$root.locationPlaceId,
					"1y"
				);
				var form = new FormData();
				form.append("placeId", placeid);
				axios.post(`${this.$root.api_url}/pim/get-lat-long`,form)
				.then((res) => {
			
					if(res.success=true){
					      
					 		this.$root.location.lat = res.data.data.google_lat;
							this.$root.location.long = res.data.data.google_long;
							this.$root.isLocation = true;

							$cookies.set(
								window.location.hostname.substring(10, 4) + "_location_lat",
								this.$root.location.lat,
								"1y"
							);
							$cookies.set(
								window.location.hostname.substring(10, 4) + "_location_long",
								this.$root.location.long,
								"1y"
							);
							this.placeinput=''
							this.suggestions=[]
							this.islocationDetected = false;
							if(res.data.data.google_sublocaility){
							this.$root.cityName = res.data.data.google_sublocaility;
							}
							else{
								this.$root.cityName = res.data.data.google_locality;
							}
							
						    this.$root.locationAddress = res.data.data.google_formatted_address;
						
						    this.getStoresData()
								
								this.isLocation = false;
								
								this.$router.go();
								// window.reload();
								
					}
					else{
						console.log(res.data.error_message)
					}
				})
				.catch((err) => {
					console.log(err)		
					this.navSearchloader = false;
				});

			},
			placesuggest(){
				let val=document.getElementById("infd").value
			   if(val.length>2){
				var form = new FormData();
				form.append("name", val);
				axios.post(`${this.$root.api_url}/pim/place-autosuggestion`,form)
				.then((res) => {
					this.autosuggestion=true
					if(res.data.status=='OK'){
					this.suggestions=res.data.predictions
					
					}
				})
				.catch((err) => {
					console.log(err)		
				});
			   }
			   else{
				   
				   this.suggestions=[]
			   }
			},
			setPlace(place) {
			
				this.$root.locationPlaceId = place.place_id;
				$cookies.set(
					window.location.hostname.substring(10, 4) + "_location_placeId",
					this.$root.locationPlaceId,
					"1y"
				);
				this.$root.location.lat = place.geometry.location.lat();
				this.$root.location.long = place.geometry.location.lng();
				this.$root.isLocation = true;

				$cookies.set(
					window.location.hostname.substring(10, 4) + "_location_lat",
					this.$root.location.lat,
					"1y"
				);
				$cookies.set(
					window.location.hostname.substring(10, 4) + "_location_long",
					this.$root.location.long,
					"1y"
				);
				this.getStoresData()
				this.currentPlace = place;
				this.isLocation = false;
				// this.reverseGeocode();
				
			},
			addMarker() {
				if (this.currentPlace) {
					const marker = {
						lat: this.currentPlace.geometry.location.lat(),
						lng: this.currentPlace.geometry.location.lng(),
					};
					this.markers.push({ position: marker });
					this.places.push(this.currentPlace);
					this.center = marker;
					this.currentPlace = null;
				}
			},
			geolocate: function () {
				navigator.geolocation.getCurrentPosition((position) => {
					this.center = {
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					};
				});
			},
			getLocation() {
				this.islocationDetected = true;
				if(navigator.permissions) {
					navigator.permissions
					.query({ name: "geolocation" })
					.then((permissions) => {
						if (permissions.state == "denied") {
							this.error =
								"You have blocked WNDW from tracking your location. To use this, change your location settings in browser.";
						} else {
							return;
						}
					});

				}
				
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition((position) => {
						this.$root.location.lat = position.coords.latitude;
						this.$root.location.long = position.coords.longitude;
						this.$root.isLocation = true;
						// this.reverseGeocode();

						//   $cookies.set(keyName, value[, expireTimes[, path[, domain[, secure[, sameSite]]]]])
						$cookies.set(
							window.location.hostname.substring(10, 4) + "_location_lat",
							this.$root.location.lat,
							"1y"
						);
						$cookies.set(
							window.location.hostname.substring(10, 4) + "_location_long",
							this.$root.location.long,
							"1y"
						);
						this.isLocation = false;
						this.getStoresData();
						// this.$router.push('/')
						//  console.log(position);
					},
						 (error) => {
							this.islocationDetected = false;
							// console.log("called error");
							console.log(error.message);
						},
						{
							enableHighAccuracy: true,
							// , timeout: 5000
						});
				} else {
					this.error =
						"You have blocked LHM from tracking your location. To use this, change your location settings in browser.";
				}
			},
			resetSearch() {
				this.isSearch = false;
				this.isSearchSpin = false;
				this.search = "";
				document.getElementById("navSearchvalue").value=''
			},
			toggleSearch() {
			
				this.isMobileSearch = !this.isMobileSearch;
			},
			wishlist() {
				this.$router.push({ name: "Wishlist" });
				this.toggleNav();
			},
			bottomnavwishlist() {
				this.$router.push({ name: "Wishlist" });
				
			},
			
			visittopage(toname){
				this.$router.push({ name: toname });
				this.toggleNav();
			},
			bottomnavpage(url_key,id_category,menu_url_key){
				this.$router.push({ path: '/page/' + url_key + '.html', });
				this.toggleNav();
			},
			minicart_show_hide() {
				if (this.$root.minicart) {
					this.$root.minicart = false;
				} else {
					// this.$root.minicart = true;
				}
			},
			toggleLogin() {
				// console.log("called");
				this.$root.login_popup = true;
				
			},
			toggleLoginDetail() {
				this.$router.push({ name: "dashboard" });
				// this.$root.login_detail = true
			},
			navDebouncesearch(){
				let searchvalue=document.getElementById("navSearchvalue").value
					this.search=searchvalue
	

				if(searchvalue.trim().length == 0) {
					this.navSearchloader = false;
					this.navSearchclose = false;
					this.navNoResult = false;
					this.navSearchResult = false;
					this.navNewSearching = false;
					this.newNavSearch = false;
					this.brands =  [];
					this.stores =  [] ;
					this.products =  []
					this.categories =  [];

				}
				else if( searchvalue.trim().length <=2 ){
					this.brands =  [];
					this.stores =  [] ;
					this.products =  []
					this.categories =  [];
					this.navSearchloader = false;
					this.navSearchclose = false;
					this.navNoResult = false;
					this.navSearchResult = false;
					this.newNavSearch = false;
					this.navNewSearching = false;
				}
				else{
					this.navNoResult = false;
					this.navSearchResult = false;
					this.navSearchloader = true;
					this.navSearchclose = true;
					this.newNavSearch = true;
					this.navNewSearching = true;	
					clearTimeout(debouncetimer);
					debouncetimer= setTimeout(() => {
						this.getStoresSearch()
						}, 1000);
				}


			},

			getStoresSearch() {
				let searchvalue=document.getElementById("navSearchvalue").value.replace(/\s+/g, ' ').trim();
				this.search=searchvalue
				if (searchvalue.trim().length > 2) {
					 
					axios	
						.get(
							`${this.$root.api_url}/pim/get-nearby-data/${this.$root.location.lat}/${this.$root.location.long}?search=true&q=${searchvalue}`
						)
						.then((res) => {
							if(res.data.sortingstores){
								
							res.data.sortingstores.forEach(element => {
							this.hightlightstore.push(element[0].id)
							
							});
							}
							console.log(res);
							this.brands = res.data.brands ? res.data.brands : [];
							this.stores = res.data.stores ? res.data.stores : [] ;
							this.products = res.data.products ? res.data.products : []
							this.products.reverse()
							// this.categories = res.data.categories ? res.data.categories : [];
							this.navSearchloader = false;
							this.navNewSearching = false;
					
							if(this.products == 0) {
								this.navNoResult = true;
								this.navSearchResult = false;
							}
							else{
								this.navNoResult = false;
								this.navSearchResult = true;
							}
						})
						.catch((err) => {
							this.brands =  [];
					         this.stores =  [] ;
					        this.products =  []
					        this.categories =  [];
							console.log(err);
							// this.navSearchloader = false;
								// this.navNoResult = true;
							console.log('bad request 400')
							this.navSearchloader = false;
							this.navNewSearching = false;
							this.navNoResult = true;
						});
				}
			},
			
			menuData(id = null, name) {
			  this.visitMenu=this.dataMenu
				if (id !== null) {
					this.navStack.push({
						name: name,
						index: id,
					});
				
					this.dataMenu = this.dataMenu[id].childs;
					
					
				} else {
					this.dataMenu = this.$root.menu;
				}
			 
			 this.dataMenu.forEach(element => {
				
				 if(element.childs!=undefined){
                  this.isGoPage=false
				 }
				 else{
					 this.isGoPage=true
				 }
				 
			 });
			 console.log("data menu",this.dataMenu)
			},
			goPage(url){
				this.toggleNav()
				this.$router.push({ path:'/category/'+url+'.html'});
			},
			visitPage(){
				var urlIndex=this.navStack[this.navStack.length-1].index
				var dataUrls=this.visitMenu[urlIndex]
				this.toggleNav()
				this.$router.push({ path:'/category/'+dataUrls.menu_url_key +'.html'});
			},
			backNav() {
				console.log(this.navStack)
				let filteredNav = this.$root.menu;
				if (this.navStack.length == 2) {
					this.dataMenu = filteredNav[this.navStack[0].index].childs;
					this.navStack.pop();
				} else {
					this.dataMenu = filteredNav;
					this.navStack.pop();
				}
				this.visitMenu=this.$root.menu;
				this.dataMenu.forEach(element => {
				
				 if(element.childs!=undefined){
                  this.isGoPage=false
				 }
				 else{
					 this.isGoPage=true
				 }
				 
			 });
			},
			toggleNav: function () {
				this.$root.isStore = true
				this.dataMenu = this.$root.menu;
				this.navStack = [];
				let body = document.getElementsByTagName("body")[0];
				if (!this.isActive) {
					body.style.overflow = "hidden";
				} else {
					body.style.overflow = "scroll";
				}
				this.isActive = !this.isActive;
				this.isGoPage=false
				// console.log(this.isActive);
			},
			
			enterFirstLink : function (){
				this.newNavSearch = false;
				this.navSearchloader = false;
				this.newNavSearch = false;
				// let firtLink = document.querySelector('.categoryLink').getAttribute("href");
				this.$router.push({ path:'/category/all.html' , query: { sq: this.search},});
				document.getElementById("navSearchvalue").value=''
				this.search = "";
				this.$root.isStore = false
				this.$root.searchCount += 1
				
			}
		},
	};
</script>
<style scoped>
.storeLoader{
	width: 100%;
	min-height: 300px;
	text-align: center;
}
ul.place-dropdown.autosuggest {
    left: 0;
    top: 61px;
    box-shadow: none;
}


.newNavActiveSearch {
	width: 550px;
	transition: all .3s ease-in-out;
    margin: auto;
	margin-right: auto!important;
    /* position: relative; */
}
.navSearchInputField {
    display: block;
    background: #fff;
    width: 100%;
    padding: 8px;
    border: 1px solid #fff;
    transition: width .2s ease-in-out;
    color: #888;
    border-radius: 2px;
    font-size: var(--font-size-regular);
}
.navSearchInputField:focus {
	outline: none;
	border: 1px solid #fff;
}

.navNewSearch {
 	position: absolute;
  	top:40px;
  	height: auto;
  	width: 100%;
  	padding: 4px;
  	margin: 0px;
  	background-color: transparent;
}
.navNewSearch::before {
 	position: absolute;
	content: "";
	width: 10px;
	height: 10px;
	background: white;
	left: 30px;
	top: 9px;
	transform: rotate(45deg);
	border-top: 1px solid #d4d4d4;
	border-left: 1px solid #d4d4d4;
}
.nawSearchNotch{
  overflow-y: auto;
    max-height: 400px;
    margin-top: 10px;
    background-color: #fff;
}

.nawSearchNotchResult {
	display: flex;
	flex-direction: row-reverse;
}
.navSearchProduct {
	width: 65%;
    border-left: 1px solid rgb(235, 236, 240);
    padding: 1rem;
    display: flex;
    flex-direction: column;
}
.navSearchProduct a b.search-text { 
	color:#282c3f;
	font-family: 'lhmBold'
}
.navSearchProduct a {
	font-size: 13px !important;
    padding: 5px 0;
    display: block;
    margin-top: 0!important;
    font-family: 'lhmSemiBold';

}
.navSearchStore  a { 
	font-size: 11px;
    font-family: 'lhmSemiBold';
    color: #626262;
    display: block;
    padding: 5px 0;
    margin-top: 0!important;
}

.navSearchStore p.headingName{
	font-size: var(--font-size-regular)!important;
    color: #ba2126;
    margin-bottom: 2px;
    text-transform: uppercase;
    font-family: lhmBold;
    padding-top: 8px;
}



.nawSearchNotchresult{
      /* border-left: 1px solid rgb(235, 236, 240); */
    padding: 1rem;
    width: 100%;
}
.navRemoveIcon::before{
	display: none;
}

.newspinner {
    position: absolute;
    top: 4px !important;
    font-size: 18px !important;
    right: 40px !important;
}
@media screen and (max-width:767px) {
	.navSearchInputField {
		position: initial;
    	margin: 4px auto;
		width: 98%;
	}

	.navNewSearch {
		padding: 0;
		    background: white;
    padding-bottom: 10px;
	position: initial;
	}
	.nawSearchNotch {
		margin:0 ;
		border: 0;
	}
	.newspinner {
		top: 9px !important;
	}
	.search-icon::before {
		content: '\e801';
	}
	.nawSearchNotch.nawSearchNotchResult.navSerachReuslts {
    border: 1px solid #d4d4d4;
    margin: 10px 5px;
    margin-bottom: 0px;
}
	.nawSearchNotchResult {
		display: block;
	}
	
}
</style>